import { Card, Row, Col, Typography, Button } from 'antd';
import notFoundImg from '../../../assets/notFound.png';
import { RollbackOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './404.scss';
const { Paragraph, Title } = Typography;

const NF404 = () => {
    const { t } = useTranslation();

    return (
        <div className="notFound">
            <Card>
                <Row gutter={{ lg: 24 }}>
                    <Col className="gutter-row textNF" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <Title level={3}>{t('messages.pageNotFound')}</Title>
                        <Paragraph>
                            {t('messages.pageNotFoundMessage')}
                        </Paragraph>
                        <a href="/"><Button type="dashed" icon={<RollbackOutlined />}> {t('general.returnToHomepage')}</Button></a>
                    </Col>

                    <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <img src={notFoundImg} alt="Page not found" />
                    </Col>
                </Row>
            </Card>
        </div>
    );
}

export default NF404